import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 4.274L12 2 4 4.274v8.71c0 3.92 2.977 6.828 7.594 8.87l.332.146.349-.1C18.383 20.165 20 15.332 20 12.985v-8.71zm-14 8.71V5.775l6-1.705 6 1.705v7.21c0 1.595-1.129 5.375-5.93 6.899C7.92 17.972 6 15.627 6 12.984zM10.505 16c0-.828.67-1.5 1.495-1.5.826 0 1.495.672 1.495 1.5s-.67 1.5-1.495 1.5a1.497 1.497 0 01-1.495-1.5zm.254-9.173c.19-.21.46-.328.743-.327h.996a.995.995 0 01.997 1.1l-.498 5c-.13 1.2-1.874 1.2-1.994 0l-.498-5a1.002 1.002 0 01.254-.773z",
      fill: "#2d6ded"
    }
  )
), c = l;
export {
  c as default
};
